import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Subtitle} from '../../subtitle'
import {useSettings} from '../../../../hooks/settings'
import {settingsParams} from '../../../../settingsParams'
import {useVisibilityStyles} from '../../../../hooks/use-visibility-styles'
import s from './schedule.scss'
import {List} from './list'
import {Footer} from './footer'
import {ScheduleProps} from '.'

export const Schedule = ({t, items, total, navigateToSchedulePage, componentSettings}: ScheduleProps) => {
  const {
    allBreakpoints: {isScheduleVisible},
  } = useVisibilityStyles()
  const settings = useSettings(componentSettings)
  const scheduleTitleText = settings.get(settingsParams.scheduleTitleText)

  if (!isScheduleVisible()) {
    return null
  }

  return (
    <div className={s.container} data-hook={DH.SCHEDULE}>
      <Subtitle dataHook={DH.SCHEDULE_SUBTITLE} text={scheduleTitleText} />
      <List t={t} items={items} />
      <Footer total={total} t={t} navigateToSchedulePage={navigateToSchedulePage} />
    </div>
  )
}
